module.exports = __webpack_public_path__ + "static/media/cat-jewllery.d0432bf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cat-jewllery.jpg
// module id = 1111
// module chunks = 33